import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Class } from '../../../interfaces/class.interface';
import { GetClassesParams, GetClassesResponse } from '../interfaces/get-classes';
import { RequestError } from '../../../interfaces/error.interface';
import { GetClassResponse } from '../interfaces/get-class';

export interface ClassState {
  classes: Class[];
  class: Class | null;
  options: GetClassesParams;
  errorCode: number | null;
}

const initialState: ClassState = {
  classes: [],
  class: null,
  options: {},
  errorCode: null,
};

const classSlice = createSlice({
  name: 'class',
  initialState,
  reducers: {
    getClassesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getClassesSuccessApiAction: (state, action: PayloadAction<GetClassesResponse>) => {
      state.classes = action.payload.classes;
    },
    getClassesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getClassInitApiAction: (state) => {
      state.errorCode = null;
    },
    getClassSuccessApiAction: (state, action: PayloadAction<GetClassResponse>) => {
      state.class = action.payload.class;
    },
    getClassFailureApiAction: (state,action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    postClassInitApiAction: () => {},
    postClassSuccessApiAction: () => {},
    postClassFailuireApiAction: () => {},
    postClassSeenInitApiAction: () => {},
    postClassSeenSuccessApiAction: () => {},
    postClassSeenFailuireApiAction: () => {},
    putClassInitApiAction: () => {},
    putClassSuccessApiAction: () => {},
    putClassFailuireApiAction: () => {},
    setOptionsAction: (state, action: PayloadAction<GetClassesParams>) => {
      state.options = action.payload;
    },
    resetOptionsAction: (state) => {
      state.options = {};
    },
    classClearAction: (state) => {
      state.classes = [];
      state.class = null;
    },
  },
});

export const {
  getClassesInitApiAction,
  getClassesSuccessApiAction,
  getClassesFailureApiAction,
  getClassInitApiAction,
  getClassSuccessApiAction,
  getClassFailureApiAction,
  postClassInitApiAction,
  postClassSuccessApiAction,
  postClassFailuireApiAction,
  putClassInitApiAction,
  putClassSuccessApiAction,
  putClassFailuireApiAction,
  postClassSeenInitApiAction,
  postClassSeenSuccessApiAction,
  postClassSeenFailuireApiAction,
  setOptionsAction,
  resetOptionsAction,
  classClearAction,
} = classSlice.actions;

export default classSlice.reducer;
